import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { DropdownInputComponent } from "@app/kernel/form/modules/inputs/simple-inputs/components/dropdown-input/dropdown-input.component";
import { TextAreaComponent } from "@app/kernel/form/modules/inputs/simple-inputs/components/text-area/text-area.component";
import { FilePickerComponent } from "@app/shared-core/components/file-picker/file-picker.component";
import { DRIVER_DROPDOWN_QUERY } from "@app/applications/movements-management/shared/driver/queries/driver-dropdown.query";
import { InternalNoteComponent } from "@app/applications/movements-management/shared/internal-note/components/internal-note/internal-note.component";
import { IConfirmMovementControls } from "../../interfaces/confirm-movement-controls.interface";

/**
 * "Additional Information" column the Confirm action shows beside the onboarding steps: the driver (required), the
 * external note, the files and the internal note. It only renders the form it is given.
 */
@Component({
  selector: "app-confirm-movement-section",
  templateUrl: "./confirm-movement-section.component.html",
  styleUrl: "./confirm-movement-section.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslatePipe, DropdownInputComponent, TextAreaComponent, FilePickerComponent, InternalNoteComponent],
})
export class ConfirmMovementSectionComponent {
  /** The section's form, passed by the onboarding dialog. */
  public readonly form = input.required<FormGroup<IConfirmMovementControls>>();

  /** Selection of the driver options. */
  protected readonly driverQuery = DRIVER_DROPDOWN_QUERY;

  /** Fields the driver search matches the typed term against. */
  protected readonly driverSearchFields = ["mainInfo.name", "personalData.fiscalCode"];

  /** Search icon of the driver dropdown. */
  protected readonly searchIcon = { name: "magnifying-glass" };
}
